<div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="treatment-teeth-group-dialog-main-container">
  <div class="section-header" style="flex-basis: 30px;" data-cy="treatment-teeth-group-dialog-section-header">
    <div class="section-header-title" data-cy="treatment-teeth-group-dialog-header-title">
      Group of Teeth to Present
    </div>
    <div style="flex: 1;"></div>
  </div>
  <app-tdo-progress-spinner style="flex: 1;" *ngIf="isLoading" data-cy="treatment-teeth-group-dialog-progress-spinner"></app-tdo-progress-spinner>
  <div *ngIf="!isLoading" class="section-content" style="flex: 1; max-height: 300px; height: 300px;" data-cy="treatment-teeth-group-dialog-section-content">
    <div style="max-height: 288px; height: 288px;" data-cy="treatment-teeth-group-dialog-table-container">
      <tdo-table [isSearchable]="false" [dataSource]="toothGroupTable" (rowContextMenu)="onRowContextMenu($event)" data-cy="treatment-teeth-group-dialog-tooth-group-table">
        <tdo-table-column displayName="Tooth" propertyName="tooth" [isSortable]="true"
                          [rowTemplate]="ToothNumber" data-cy="treatment-teeth-group-dialog-tooth-column">
          <ng-template #ToothNumber let-row>
            {{row.model.Tooth}}
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Date of Visit" propertyName="dateOfVisit" [isSortable]="true"
                          [rowTemplate]="DayOfVisit" data-cy="treatment-teeth-group-dialog-date-of-visit-column">
          <ng-template #DayOfVisit let-row>
            {{row.model.DayOfVisit | date}}
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Group" propertyName="isAlreadyInGroup" [isSortable]="true"
                          [rowTemplate]="Group" data-cy="treatment-teeth-group-dialog-group-column">
          <ng-template #Group let-row>
            {{row.model.ToothGroupDescription}}
          </ng-template>
        </tdo-table-column>
        <tdo-table-column propertyName="alreadyInGroup" [isSortable]="true" [rowTemplate]="alreadyInGroup" data-cy="treatment-teeth-group-dialog-already-in-group-column">
          <ng-template #alreadyInGroup let-row>
            <div style="margin-top: 7px; display: flex;" data-cy="treatment-teeth-group-dialog-already-in-group-checkbox-container">
              <mat-checkbox style="margin-right: 4px;" [checked]="row.model.isInGroup" [disabled]="row.model.ToothGroupDescription === ''"
                            (change)="onInGroupChange($event, row)" data-cy="treatment-teeth-group-dialog-already-in-group-checkbox"></mat-checkbox>
            </div>
          </ng-template>
        </tdo-table-column>
      </tdo-table>
    </div>
  </div>
  <div class="section-footer" style="flex-basis: 50px; min-height: 50px; padding-top: 8px;" data-cy="treatment-teeth-group-dialog-section-footer">
    <span style="padding-left: 15px" data-cy="treatment-teeth-group-dialog-footer-help-text">* Right click to assign or create a group</span>
    <div style="flex: 1; margin-right: 6px;"></div>
    <button (click)="onOkClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-teeth-group-dialog-ok-button">Ok</button>
    <button (click)="onCancelClick()" class="tdo-button primary-accent" style="margin-right: 6px;" data-cy="treatment-teeth-group-dialog-cancel-button">Cancel</button>
  </div>
</div>
<ng-template #ledgerItemContextMenu let-data data-cy="treatment-teeth-group-dialog-context-menu">
  <section class="image-context-menu" data-cy="treatment-teeth-group-dialog-context-menu-section">
    <div *ngFor="let group of this.toothGroup; let i = index">
      <div data-cy="treatment-teeth-group-dialog-context-menu-select-group-item-{{i}}" (click)="selectGroup(data, i)" class="item">{{group.Description}}</div>
    </div>
    <div data-cy="treatment-teeth-group-dialog-context-menu-create-new-group-item" (click)="createNewGroup()" class="item">
      Create New Group
    </div>
    <div *ngIf="data.ToothGroupId !== null" data-cy="treatment-teeth-group-dialog-context-menu-remove-from-group-item" (click)="removeFromGroup(data)" class="item">
      Remove From Group
    </div>
  </section>
</ng-template>
